var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10705_7018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9313 33.0067H6.78571C5.52335 33.0067 4.5 34.0301 4.5 35.2924V62.7946H67.217V35.2924C67.217 34.0301 66.1936 33.0067 64.9313 33.0067Z",
    fill: "#F0C1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0714 10.8571H22.7857C21.5233 10.8571 20.5 11.8805 20.5 13.1428V62.8571H51.3571V13.1428C51.3571 11.8805 50.3338 10.8571 49.0714 10.8571Z",
    fill: "#FFDBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6426 33.1429H25.6426V41.1429H33.6426V33.1429Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3574 35.4286H39.3574V43.4286H47.3574V35.4286Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5001 37.1429H39.9287V45.7143H48.5001V37.1429Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.23 37.1429H7.76855V45.5634H16.23V37.1429Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.23 49.7143H7.76855V58.1348H16.23V49.7143Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9478 37.1429H55.4863V45.5634H63.9478V37.1429Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9478 49.7143H55.4863V58.1348H63.9478V49.7143Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.071 14.8571H34.7853C34.4697 14.8571 34.2139 15.113 34.2139 15.4285V28C34.2139 28.3156 34.4697 28.5714 34.7853 28.5714H37.071C37.3866 28.5714 37.6424 28.3156 37.6424 28V15.4285C37.6424 15.113 37.3866 14.8571 37.071 14.8571Z",
    fill: "#002E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2141 20H29.6427C29.3271 20 29.0713 20.2558 29.0713 20.5714V22.8571C29.0713 23.1727 29.3271 23.4286 29.6427 23.4286H42.2141C42.5297 23.4286 42.7856 23.1727 42.7856 22.8571V20.5714C42.7856 20.2558 42.5297 20 42.2141 20Z",
    fill: "#002E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0711 49.1429H25.6426V62.8572H45.0711V49.1429Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.357 50.8571H45.0713V62.8571H47.357V50.8571Z",
    fill: "#E580B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.071 48H34.2139V62.8571H37.071V48Z",
    fill: "#FFDBED"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5415 48.7139L49.7803 51.9778L65.1525 69.6557L68.9137 66.3918L53.5415 48.7139Z",
    fill: "#7DAED4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.054 73.7498L72.0108 73.7873C70.8245 74.8171 69.2356 74.9306 68.462 74.0411L59.5362 63.9336L63.9118 59.9664L72.8019 70.2751C73.5755 71.1646 73.2408 72.7202 72.0545 73.75L72.054 73.7498Z",
    fill: "#002E52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1448 58.3444C61.7896 54.292 64.7054 44.8332 60.6573 37.2177C56.6093 29.6021 47.1304 26.7136 39.4857 30.766C31.8409 34.8184 28.9251 44.2771 32.9731 51.8927C37.0211 59.5083 46.5 62.3968 54.1448 58.3444Z",
    fill: "#002E52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3498 55.7196C49.6102 57.6384 56.2406 54.1188 58.1594 47.8585C60.0781 41.5981 56.5586 34.9677 50.2982 33.0489C44.0379 31.1302 37.4074 34.6497 35.4887 40.9101C33.5699 47.1704 37.0895 53.8009 43.3498 55.7196Z",
    fill: "#7DAED4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9261 40.2855C56.6885 36.94 53.9577 34.1887 50.2814 33.0619C44.0276 31.1452 37.4058 34.6553 35.4912 40.9021C35.018 42.4457 34.8767 44.0121 35.0263 45.5245L57.9261 40.2855Z",
    fill: "#7DAED4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2478 59.2408L64.2478 59.2408L64.2843 59.2906C64.5282 59.6207 64.4818 60.0816 64.1781 60.357L64.2478 59.2408ZM64.2478 59.2408L64.2468 59.2394C63.9639 58.8566 63.4104 58.8038 63.0604 59.1275L58.9294 62.9466L58.9293 62.9466C58.6002 63.251 58.5857 63.7654 58.8963 64.088L58.8963 64.088L58.8987 64.0904L58.9031 64.095C59.2029 64.4043 59.695 64.4217 60.0149 64.1315C60.015 64.1314 60.0151 64.1314 60.0151 64.1313L64.178 60.357L64.2478 59.2408Z",
    fill: "#F0C1D9",
    stroke: "#F0C1D9",
    strokeWidth: 0.846844
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6179 46.2843L45.6263 46.2927L45.6354 46.3004C45.8543 46.4856 46.1205 46.5727 46.4155 46.5727C46.7023 46.5727 46.9611 46.4831 47.1771 46.3004L47.1772 46.3006L47.1863 46.2922C47.3993 46.0956 47.5202 45.8483 47.5202 45.5611C47.5202 45.1174 47.6355 44.7667 47.8504 44.4901C48.1041 44.1673 48.4882 43.7987 49.0121 43.3844C49.4265 43.0579 49.7647 42.7649 50.0236 42.506L50.0237 42.5061L50.0285 42.501C50.2992 42.2167 50.5265 41.8812 50.7117 41.4976L50.7117 41.4976L50.7133 41.4942C50.9075 41.078 51.0007 40.6074 51.0007 40.0891C51.0007 38.9327 50.5841 37.9927 49.7434 37.3007C48.9221 36.6145 47.84 36.2857 46.5272 36.2857C45.8741 36.2857 45.2723 36.3561 44.7239 36.4998C44.1721 36.6443 43.6311 36.8861 43.1013 37.2217C42.7334 37.4434 42.5004 37.76 42.5004 38.1721C42.5004 38.4513 42.6086 38.6964 42.8074 38.8952C43.0063 39.0941 43.2514 39.2023 43.5306 39.2023C43.7526 39.2023 43.9605 39.1335 44.1497 39.0085C44.4432 38.8285 44.7795 38.6912 45.1614 38.5986L45.1614 38.5987L45.1672 38.5972C45.5653 38.4918 45.9688 38.4392 46.3783 38.4392C47.2373 38.4392 47.8292 38.6043 48.2013 38.8879C48.5587 39.1603 48.7541 39.5739 48.7541 40.1822C48.7541 40.4626 48.666 40.7091 48.4837 40.9319C48.2794 41.1816 47.9504 41.4894 47.4855 41.8564L47.4855 41.8564L47.4833 41.8581C47.0309 42.2226 46.6609 42.5537 46.3766 42.851L46.3764 42.8512C46.0902 43.151 45.8445 43.5257 45.6359 43.9691C45.4162 44.4358 45.3109 44.9689 45.3109 45.5611C45.3109 45.8404 45.419 46.0854 45.6179 46.2843ZM45.4261 50.7006L45.4317 50.7066L45.4376 50.7122C45.7122 50.9715 46.0423 51.1066 46.4155 51.1066C46.7981 51.1066 47.1324 50.9733 47.3993 50.7065C47.6751 50.4307 47.818 50.0916 47.818 49.7041C47.818 49.3277 47.6739 49.001 47.3993 48.7389C47.1347 48.4617 46.8007 48.3203 46.4155 48.3203C46.037 48.3203 45.7051 48.4657 45.4318 48.739C45.1674 49.0034 45.0317 49.3304 45.0317 49.7041C45.0317 50.0865 45.1645 50.4237 45.4261 50.7006Z",
    fill: "#002E52",
    stroke: "#002E52",
    strokeWidth: 0.571429
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10705_7018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.717,
    height: 51.9375,
    fill: "white",
    transform: "translate(4.5 10.8571)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHospital);
export default __webpack_public_path__ + "static/media/no-hospital.843a1005ef631217d95e5173dadece92.svg";
export { ForwardRef as ReactComponent };